<template>
    <div>
        <div class="page">
            <Spin :spinning="loading">
                <div class="policy-list">
                    <div class="item" v-for="item in list" :key="item.id">
                        <div class="unit" :title="item.unit">【{{ cutStr(item.unit, 10) || "暂无" }}】</div>
                        <div class="address" :title="item.policyName">
                            {{ cutStr(item.policyName, 20) || "暂无" }}
                        </div>
                        <div class="money" v-if="item.leaveTime != -1">
                            最高补贴：{{ item.policySubsidy || "0" }}万元
                        </div>
                        <div class="money" v-else></div>

                        <div class="view f-r-sc">
                            <Icon type="eye" :style="{ color: '#999999' }" />
                            <div>{{ item.pageView || "0" }}</div>
                        </div>

                        <div class="surplus" v-if="item.leaveTime != -1">剩余{{ item.leaveTime || "0" }}天</div>

                        <Button type="primary" class="go" @click="toRemit(item.id)" v-if="item.leaveTime != -1">
                            {{ item.isMoney == 1 ? "已兑现" : "兑现" }}<Icon type="double-right" />
                        </Button>

                        <Button type="danger" class="deleteCollect" @click="changeCollect(item)" v-if="item.isCollect == 1">
                            取消收藏
                        </Button>

                        <!-- <div class="izCollect f-r-sc" v-if="item.isCollect == 1 && item.leaveTime != -1">
                            <Icon type="star" :style="{ color: '#EF2534', marginRight: '4px' }" />
                            <div>已关注</div>
                        </div> -->

                        <div class="time">{{ item.hasStartTime || "" }}</div>

                        <div class="izNew" v-if="item.isNew == 1 && item.leaveTime != -1">NEW</div>

                        <img v-if="item.leaveTime == -1" class="izSubmitted" src="@/assets/izSubmitted.png" />
                    </div>
                    <div
                        :style="{ width: '100%', margin: '100px 0 0 0', transform: 'translateX(-50px)' }"
                        class="f-r-cc"
                    >
                        <Empty v-if="list.length == 0" description="暂无数据" />
                    </div>
                </div>
            </Spin>

            <div class="pagination" v-if="total > 5">
                <Pagination
                    size="large"
                    show-quick-jumper
                    :default-current="param.pageNo"
                    :total="total"
                    @change="onChange"
                ></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "ant-design-vue";
import { getAction } from "@/util/require.js";
export default {
    name: "",
    components: {},
    data() {
        return {
            btnIndex: 1,
            param: {
                pageNo: 1,
                pageSize: 5
            },
            list: [],
            total: 0,
            loading: false
        };
    },
    created() {},
    mounted() {
        this.getData();
    },
    methods: {
        changeBtnIndex(index) {
            this.btnIndex = index;
        },
        cutStr(str, len = 10) {
            if (str) {
                if (str.length > len) {
                    return str.slice(0, len - 2) + "...";
                } else {
                    return str;
                }
            } else {
                return "";
            }
        },
        getData() {
            this.loading = true;
            getAction("/hq/webPage/checkMyCollect", { ...this.param }).then(res => {
                if (res.success) {
                    this.list = res.result.records;
                    this.total = res.result.total;
                } else {
                    Message.error(res.message);
                }
                this.loading = false;
            });
        },
        toRemit(id) {
            this.$router.push({ path: "/policyMatch/remit", query: { itemId: id } });
        },
        onChange(e) {
            this.param.pageNo = e;
            this.getData();
        },
        changeCollect(item) {
            if (item.isCollect == 1) {
                getAction("/hq/webPage/deleteCollect", {
                    id: item.id
                }).then(res => {
                    if (res.success) {
                        Message.success(res.message);
                        this.getData();
                    } else {
                        Message.error(res.message);
                    }
                });
            } else {
                getAction("/hq/webPage/createPolicyCollect", {
                    id: item.id
                }).then(res => {
                    if (res.success) {
                        Message.success(res.message);
                        this.getData();
                    } else {
                        Message.error(res.message);
                    }
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.page {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}
.btn-list {
    margin: 20px 30px 0 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .btn-item {
        width: 140px;
        height: 60px;
        border: 1px solid #087ce8;
        box-sizing: border-box;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
        color: #087ce8;
        line-height: 60px;
        cursor: pointer;
        &:nth-child(n + 2) {
            border-left: none;
        }
    }
    .btn-select {
        background: #087ce8;
        color: #fff;
        font-weight: 500;
    }
}
.policy-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 600px;
    margin-left: 60px;
    .item {
        padding: 30px 0 0 30px;
        margin-bottom: 40px;
        box-sizing: border-box;
        height: 220px;
        width: 580px;
        box-shadow: 0px 0px 12px 0px rgba(8, 124, 232, 0.15);
        border-radius: 2px;
        background: #fff;
        position: relative;
        // &:nth-child(2n) {
        //     margin-left: 40px;
        // }
    }

    .unit {
        font-size: 22px;
        font-weight: 500;
        color: #087ce8;
        text-indent: -15px;
        line-height: 1;
    }

    .address {
        margin-top: 43px;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        line-height: 1;
    }
    .money {
        margin-top: 21px;
        font-size: 20px;
        font-weight: 600;
        line-height: 1;
        color: #ed6f13;
        min-height: 20px;
    }
    .view {
        margin-top: 30px;
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        div {
            margin-left: 5px;
        }
    }

    .surplus {
        position: absolute;
        top: 28px;
        right: 21px;
        font-size: 18px;
        font-weight: 500;
        color: #e80822;
    }

    .go {
        position: absolute;
        top: 123px;
        right: 21px;
    }
    .time {
        position: absolute;
        right: 21px;
        bottom: 21px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
    }
    .izNew {
        position: absolute;
        top: 0;
        font-size: 16px;
        right: 0;
        width: 56px;
        height: 20px;
        background: #ff0012;
        border-radius: 2px 2px 2px 12px;
        color: #fff;
        line-height: 22px;
        text-indent: 2px;
        font-weight: 600;
        text-align: center;
    }

    .izCollect {
        position: absolute;
        left: 121px;
        bottom: 21px;
        font-size: 16px;
        font-weight: 400;
        color: #ef2534;
    }

    .deleteCollect{
        position: absolute;
        left: 100px;
        bottom: 16px;
    }

    .izSubmitted {
        position: absolute;
        left: 260px;
        z-index: 0;
        top: 95px;
        width: 150px;
        height: 106px;
    }
}
</style>
